<header style="background-image: url('assets/img/barrios/{{ sector.imageUrl }}');">
  <h1>Sector de Gestión <span>{{ sectorId}}</span> </h1>
  <div class="middle">
      <!--<div class="text">John Doe</div>-->
    </div>
</header>
<div class="container-fluid">
  <div class="row">
    <div class="col-md-4" style="background-color: #811643;">
      <img src="assets/img/barrios/{{sectorId}}-overlay.png" alt="" srcset="">
    </div>
    <div class="col-md-8">
      <h1>{{ sectorId }}</h1>
      <p>{{ sector.barrio }}</p>
      <p>{{ sector.descripcion}}</p>
      
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h2>Barrios Tradicionales</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h2>Festividades</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h2>Patrimonio Inmaterial</h2>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h2>Galería Fotográfica</h2>
    </div>
  </div>
  

</div>